<template>
    <el-card>
        <div slot="header">
          <span>收益曲线</span>
          <el-radio-group style="float: right; padding: 3px 0" v-model="dateRadio" @change="handleDateRadioChange">
              <el-radio-button label="sevenDay">近7天</el-radio-button>
              <el-radio-button label="sixMonth">近3个月</el-radio-button>
          </el-radio-group>
        </div>
        <div class="el-table el-table--enable-row-hover el-table--medium">
            <div :ref="className" :style="{height:height,width:width}" />
        </div>
    </el-card>
</template>
<script>
import * as echarts from "echarts";
import {lineWithdrawalCommission} from "@/api/api.js";
export default {
  name: 'commissionAccountChart',
  data() {
    return {
      chart:null,
      dateRadio:'sevenDay',
      timeList:[],
      commissionAmountList:[]
    }
  },
  props: {
    className: {
      type: String,
      default: 'incomeCommission'
    },
    width: {
      type: String,
      default: '100%'
    },
    height: {
      type: String,
      default: '360px'
    }
  },
  methods: {
    initChart() {
      this.chart = echarts.init(this.$refs.incomeCommission);
      this.chart.setOption({
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross',
            crossStyle: {
              color: '#999'
            }
          }
        },
        toolbox: {
          feature: {
            magicType: { show: true, type: ['line', 'bar'] },
            restore: { show: true },
            saveAsImage: { show: false }
          }
        },
        color: ['#36a3f7'],
        legend: {
          data: ['实分润金额']
        },
        xAxis: [
          {
            type: 'category',
            data: this.timeList,
            axisPointer: {
              type: 'shadow'
            }
          }
        ],
        yAxis: [
          {
            type: 'value'
          }
        ],
        series: [
          {
            name: '佣金金额',
            type: 'bar',
            data: this.commissionAmountList
          },
          {
            name: '金额走势',
            type: 'line',
            label: {
                show: false,
            },
            tooltip: {
                show: false,
            },
            itemStyle: {
                color: '#4870DB',
            },
            lineStyle:{
                width:1
            },
            data: this.commissionAmountList
          }
        ]
      })
    },
    handleDateRadioChange(date){
        if(date =='sevenDay'){
            this.lineWithdrawalCommissionMethod("1");
        }
        if(date=='sixMonth'){
            this.lineWithdrawalCommissionMethod("2");
        }
    },
    lineWithdrawalCommissionMethod(type){
        let params = {
          type:type
        }
        lineWithdrawalCommission(params).then(res=>{
          if(res.data.code == 200){
              this.timeList = res.data.data.key;
              this.commissionAmountList = res.data.data.value;
              this.initChart();
          }
        })
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.initChart()
    })
  },
  beforeDestroy() {
    if (!this.chart) {
      return
    }
    this.chart.dispose()
    this.chart = null
  },
  created(){
    this.lineWithdrawalCommissionMethod("1");
  }
}
</script>
<style lang="scss" scoped>

</style>


